import { message } from "antd";
import { action, observable, computed } from "mobx";
import { createContext } from "react";
import { fetchMemberInfoApi, fetchProductApi } from "../api/api";
import { MemberInfo, formatMember } from "../format/formatAuth";
import _ from "@shared/scripts/utils/underscore-extensions";

interface ProductInfo {
  price?: number;
  final_price?: number;
  desc?: string;
}
class AuthStore {
  // 用户信息
  @observable public currentUser = window.currentUser;
  @observable public memberLoading = true;
  // 会员信息 (可能无)
  @observable public memberInfo: MemberInfo | null = null;
  // 购买会员用的商品id 需要对齐测试环境
  @observable public shopId: string = "e17b1b98-62c0-4c99-aa30-70019b2a21a1";
  @observable public xyText = "请阅读并勾选协议，否则无法进行操作";
  //《用户服务协议》链接
  @observable public xy =
    "https://www.jiqizhixin.com/agreement/4c3cee0e-b2b3-4925-84c7-91160bb0000c";
  // 商品信息（购买会员）
  @observable public productInfo: ProductInfo = {
    //     price: 10000,
    //     final_price: 10000,
    //     desc: `1、如果您是海外用户，请添加小助手协助您解决购买
    // 2、机器之心PRO会员属于虚拟产品，如您在订阅服务有效期内主动终止或取消订阅的，机器之心将不予退还与剩余有效期内对应的服务费用
    // 3、支付完成后，您可联系客服开具发票`
  };
  @observable public dialog = {
    params: {},
    buyVip: false,
  };

  @computed
  get isLogin() {
    return !_.isEmpty(this.currentUser);
  }

  get isMember() {
    return !_.isEmpty(this.memberInfo) && this.memberInfo?.articleVip;
  }

  @action
  public setMemberLoading = async (v: boolean) => {
    this.memberLoading = v;
  };

  @action
  public setMemberInfo = async (v: MemberInfo) => {
    this.memberInfo = v;
  };

  @action
  public fetchMemberInfo = async () => {
    try {
      this.setMemberLoading(true);
      const res = await fetchMemberInfoApi();
      const user = formatMember(res.user);
      this.setMemberInfo(user);
      this.setMemberLoading(false);
    } catch (e) {
      // 这里可以上报日志，也可以什么都不做
      console.warn("fetchMemberApi failed:", e);
    } finally {
      this.setMemberLoading(false);
    }
  };

  @action
  fetchProductInfo = async (id?: string) => {
    this.productInfo = await fetchProductApi(this.shopId || id);
  };

  @action
  setDialog = (name: string, value: boolean) => {
    this.dialog[name] = value;
    if (name === "login" && value === false) {
      window.sessionStorage.removeItem("refresh");
    }
  };
}

export default createContext(new AuthStore());
